import React, { useEffect, useState } from 'react'
import {
	OrderItemStyle,
	Header,
	Body,
	OrderId,
	OrderDate,
	Arrow,
	OrderPrice,
	OrderQuantity,
	OrderText,
} from './style'
import { Icon } from 'components/Icon'
import ReturnItem from '../ReturnItem'
import _ from 'lodash'
import config from 'configs/config'
import { updateOrders } from '../../slices'
import { useDispatch } from 'react-redux'
import { formatPrice } from 'utils/common'
import { FormattedMessage } from 'react-intl'

const OrderItem = ({
	id = '',
	item = {},
	itemsFlow = {},
	isOpenState = false,
	isOpenByDefault = false,
	checkFlowItems,
	setOrderModal,
}) => {
	const dispatch = useDispatch()
	const [isOpen, setIsOpen] = useState(false)
	const { orderExternalId, createDate, items, price, orderId } = item

	const { refund, reclamation, exchange } = itemsFlow
	useEffect(() => {
		setIsOpen(isOpenState)
	}, [isOpenState])
	/**
	 * getStateObj {Function}
	 * @description - sub function to make proper state object format
	 * @return {Object}
	 * */
	const getStateObj = (type = '', returned = undefined) => {
		let keyValues = config.flows
		return type
			? {
					isActive: returned ? false : true,
					selectedFlow: type,
					flow: type,
					keyValue: keyValues[type],
			  }
			: {
					isActive: false,
					selectedFlow: '',
					flow: '',
					keyValue: '',
			  }
	}
	/**
	 * isItemStatus {Function}
	 * @description - generate status object based on flow items
	 * @return {Object}
	 * */
	const isItemStatus = (orderItemId, returned) => {
		if (!_.isEmpty(refund) && refund[orderItemId]) {
			return getStateObj('refund', returned)
		}
		if (!_.isEmpty(exchange) && exchange[orderItemId]) {
			return getStateObj('exchange', returned)
		}
		if (!_.isEmpty(reclamation) && reclamation[orderItemId]) {
			return getStateObj('reclamation', returned)
		}
		return getStateObj(null)
	}
	/**
	 * onOpenOrder {Function}
	 * @description - check flow items is it possible open this order or open modal
	 * */
	const onOpenOrder = (isOpenByDefault = false) => {
		if (checkFlowItems() === orderId || checkFlowItems() === undefined) {
			//setIsOpen(!isOpen)
			dispatch(updateOrders({ orderId, isOpenByDefault }))
		} else {
			setOrderModal(orderId)
		}
	}

	const isAnyExchangeItem = (items = []) => {
		let flowsArr = []
		items.forEach((item) => {
			if (!item.returned && !item.pending) {
				flowsArr.push(isItemStatus(item.orderItemId, false).flow)
			}
		})
		return flowsArr.includes('exchange')
	}

	const isNeedToShowExchangeIcon = isAnyExchangeItem(items)

	return (
		<OrderItemStyle id={id} data-index={isOpen ? 'open' : ''}>
			<Header
				isOpen={isOpen}
				onClick={() => {
					onOpenOrder(isOpenByDefault)
				}}
			>
				<div className='flex align-items-center'>
					<div className='col p-0'>
						<OrderId isOpen={isOpen}>
							<OrderText>
								<FormattedMessage
									id='orders.title'
									defaultMessage='Orders'
								/>
							</OrderText>
							{` ${orderExternalId}`}
							{isNeedToShowExchangeIcon && (
								<Icon component='returnIcon' />
							)}
						</OrderId>
						<OrderDate>
							{createDate}
							{/*{'  '}
							<OrderShipment>12h left to return</OrderShipment>*/}
						</OrderDate>
					</div>
					{/*<Status className='col'>Status: In transit</Status>*/}
				</div>
				<div>
					<Arrow isOpen={isOpen}>
						<Icon component='arrowDown' />
					</Arrow>
				</div>
				<div>
					<OrderPrice>
						{formatPrice(
							price,
							item && item.currency
								? item.currency
								: item && item.defaultCurrency
								? item.defaultCurrency
								: ''
						)}
					</OrderPrice>
					<OrderQuantity>
						{items?.length}{' '}
						<FormattedMessage
							id='orders.productsCountLabel'
							defaultMessage='products'
							values={{
								itemsCount: items?.length,
							}}
						/>
					</OrderQuantity>
				</div>
			</Header>
			<Body isOpen={isOpen}>
				{item?.items?.map((returnItem) => {
					let { orderItemId } = returnItem
					let inactiveState = returnItem.returned
						? returnItem.returned
						: returnItem.pending
						? returnItem.pending
						: false
					let isItemStatusState = isItemStatus(
						orderItemId,
						inactiveState
					)
					return (
						<ReturnItem
							key={orderItemId}
							isChecked={isItemStatusState.isActive}
							isStatus={isItemStatusState.isActive}
							selectedFlow={isItemStatusState.flow}
							flow={isItemStatusState.flow}
							keyValue={isItemStatusState.keyValue}
							returnItem={returnItem}
							defaultCurrency={
								item && item.currency
									? item.currency
									: item && item.defaultCurrency
									? item.defaultCurrency
									: ''
							}
						/>
					)
				})}
			</Body>
		</OrderItemStyle>
	)
}
export default OrderItem
